// Auto-generated by tools/generate-build-id.mjs. Do not edit.
export const BUILD_ID = '12944';
